module.exports = __webpack_public_path__ + "img/marketer.3238de98.svg";